import { NgModule } from '@angular/core';
import { FbqGgSearchPageEventBuilder } from './fbq-gg-search-page-event.builder';

@NgModule({})
export class FbqGgSearchPageEventModule {
  constructor(_fbqGgSearchPageEventBuilder: FbqGgSearchPageEventBuilder) {}
}
